import { jsx as i } from "react/jsx-runtime";
import { c as o } from "../../../index-Cu0xwYjD.js";
import '../../../assets/Divider.css';const s = "_divider_1l3v2_3", t = {
  divider: s
}, m = ({
  type: r = "default",
  width: e = "100%",
  className: d
}) => /* @__PURE__ */ i(
  "hr",
  {
    style: { width: e, borderColor: r === "default" ? "var(--el-semantic-border-graphic)" : "var(--el-semantic-border-differentiated)" },
    className: o(t.divider, d)
  }
);
export {
  m as Divider
};
